import { defineMessages } from "react-intl"

export const messages = defineMessages({
	months: {
		defaultMessage: "{warrantyPeriod} Months",
		id: "vehicleDetails.porscheApproved.months",
	},
	monthsWithPorscheAssistance: {
		defaultMessage: "{warrantyPeriod} Months (Porsche Assistance)",
		id: "vehicleDetails.porscheApproved.monthsWithPorscheAssistance",
	},
	warrantyServiceNotAvailableShort: {
		defaultMessage: "Not available",
		id: "vehicleDetails.porscheApproved.warrantyServiceNotAvailableShort",
	},
})
